/**
 * 群组信息面板
 * Bai.Zhiming
 * 2019-7-23
 */
angular.module("groupInfoPanelModule", []).
directive("groupInfoPanel", ['imService', '$q', '$timeout', function(imService, $q, $timeout) {
    return {
        restrict: "E",
        replace: true,
        scope: false,
        templateUrl: "./IM/chatWindow/infoPanel/groupInfoPanel/groupInfoPanel_tpl.html",
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [sendMessage description] 发送群消息
             * @return {[type]} [description]
             */
            scope.sendMessage = function() {
                if (angular.isFunction(scope.fn.selectedGroup)) {
                    scope.fn.selectedGroup(angular.copy(scope.status.groupInfo));
                }
            }
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                let status = {};
                let data = {};
                angular.extend(scope.status, status);
                angular.extend(scope.data, data);
            }
            /**
             * [getNickName description] 获取用户昵称
             * @param  {[type]} user [description] 用户信息
             * @return {[type]}      [description]
             */
            scope.getNickName = function(user) {
                let tag_list = [
                    "Tag_Profile_IM_Nick", //昵称
                    "Tag_Profile_IM_Image" //头像
                ];
                let options = {
                    'To_Account': [user.Member_Account],
                    'TagList': tag_list
                };
                webim.getProfilePortrait(options, resp => {
                    let item = resp.UserProfileItem[0].ProfileItem;
                    $timeout(() => {
                        user.nickName = item[0].Value;
                        user.headUrl = item[1].Value;
                    });
                }, error => {

                })
            };
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                getGroupMember();
                scope.$watch("status.groupInfo", (newV, oldV) => {
                    getGroupMember();
                })
            }
            /**
             * [getGroupMember description] 获取群组成员信息
             * @return {[type]} [description]
             */
            function getGroupMember() {
                let deffer = $q.defer();
                imService.getGroupMember(scope.status.groupInfo.GroupId, 200).then(resp => {
                    scope.status.groupInfo.memberList = resp;
                    deffer.resolve();
                }, error => {
                    deffer.reject();
                });
                return deffer.promise;
            }
        }
    };
}]);